export const parseTerms = values => {
	let terms = [];
	let raw = values.split('"');
	if (raw.length > 1) {
		parser(raw);
	} else {
		raw = values.split("'");
		if (raw.length > 1) {
			parser(raw);
		} else {
			terms = raw[0].trim().replace(/,/, "").split(" ");
			if (!terms[0]) {
				terms.shift();
			}
		}
	}
	return terms;

	function parser(arr) {
		arr = arr
			.filter(term => term != "")
			.map(term => {
				if (term.charAt(0) === " " || term.charAt(term.length - 1) === " ") {
					// not a phrase
					return term.trim().replace(/,$/, "").split(" ");
				}
				return term;
			});
		for (let i = 0; i < arr.length; i++) {
			if (typeof arr[i] === "object") {
				terms = terms.concat(arr[i]);
			} else terms.push(arr[i]);
		}
	}
};
